<template>
  <div class="relative ml-2 text-lg leading-relaxed">
    <div>
      <div class="font-heading text-lg leading-6 font-bold">
        {{ title }}
      </div>
      <div class="mt-2 text-base">
        <p>{{ address.street }} {{ address.houseNumber }}</p>
        <p class="mt-1">{{ address.zipCode }} {{ address.city }}</p>
        <div v-if="phone" class="mt-1 flex">
          <div class="shrink-0">
            <PhoneIcon class="mt-1 h-5 w-5" />
          </div>
          <div class="ml-2 text-base">
            <a
              class="link font-medium text-current"
              :href="`tel:${phone}`"
              :aria-label="`Bel ${phone} voor meer informatie`"
            >
              {{ phone }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="absolute -top-1 -left-10">
      <MapPinIcon class="h-7 w-7" />
    </div>
  </div>
</template>

<script setup>
import { PhoneIcon } from '@heroicons/vue/24/outline'
import { MapPinIcon } from '@heroicons/vue/24/solid'

defineProps({
  title: {
    type: String,
    default: '',
  },
  address: {
    type: Object,
    default: () => {},
  },
  phone: {
    type: String,
    default: '',
  },
})
</script>
